import React from "react"
import PropTypes from "prop-types"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { formatearNumero } from "helpers/formatters"
import {
  AVISO_LO_MANUAL,
  AVISOS_RECALCULAR_SCORING,
  ETIQUETA_RECALCULAR_SCORING,
  conteoUltimaCarga,
  detalleNiveles,
} from "./nivelesImportacion"

/**
 * Detalle por nivel de lo que va a pasar: qué se borra, qué se reimporta y qué no
 * se toca. `estadoPrevio` (estado de la última corrida) aporta, si hay dato, la
 * cantidad que cargó la última importación del nivel; sin dato no se muestra
 * ningún conteo (no se inventa).
 */
export const DetalleNiveles = ({
  efectiva,
  excluirArca,
  estadoPrevio,
  limpiezaCompleta = false,
  recalcularScoring = false,
}) => {
  const { filas, noToca, avisoManual, avisoLotes } = detalleNiveles(efectiva, {
    excluirArca,
    limpiezaCompleta,
  })
  return (
    <div data-testid="detalle-niveles">
      <ul className="list-unstyled mb-2">
        {filas.map(f => {
          const cargo = conteoUltimaCarga(estadoPrevio, f.nivel)
          return (
            <li
              key={f.nivel}
              className="mb-2"
              data-testid={`detalle-${f.nivel}`}
            >
              <strong>{f.etiqueta}</strong>
              <div className="small">
                <span className="text-danger">Se borra:</span> {f.borra}
              </div>
              <div className="small">
                <span className="text-success">Se reimporta:</span>{" "}
                {f.reimporta}
              </div>
              {cargo != null && (
                <div
                  className="small text-muted"
                  data-testid={`detalle-${f.nivel}-conteo`}
                >
                  La última importación cargó {formatearNumero(cargo, 0)}.
                </div>
              )}
            </li>
          )
        })}
      </ul>
      <p className="small mb-2" data-testid="detalle-no-toca">
        <strong>No se toca:</strong> {noToca}
      </p>
      {avisoLotes && (
        <p className="small text-danger mb-2" data-testid="detalle-aviso-lotes">
          {avisoLotes}
        </p>
      )}
      {avisoManual && (
        <p
          className="small text-danger mb-2"
          data-testid="detalle-aviso-manual"
        >
          {AVISO_LO_MANUAL}
        </p>
      )}
      {recalcularScoring && (
        <div className="small mb-0" data-testid="detalle-recalcular-scoring">
          <strong>{ETIQUETA_RECALCULAR_SCORING}:</strong>
          <ul className="mb-0">
            {AVISOS_RECALCULAR_SCORING.map(texto => (
              <li key={texto}>{texto}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

/**
 * Diálogo "Confirmar importación" (corrida por niveles sin limpieza completa).
 * Con la limpieza completa activa el detalle va dentro del diálogo con frase
 * existente: este no se usa.
 */
const ConfirmacionNiveles = ({
  isOpen,
  efectiva,
  excluirArca,
  recalcularScoring = false,
  estadoPrevio,
  onCancelar,
  onConfirmar,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={onCancelar}
    centered
    role="alertdialog"
    data-testid="confirmar-niveles"
  >
    <ModalHeader toggle={onCancelar}>
      <i className="mdi mdi-database-sync-outline me-2 text-primary" />
      Confirmar importación
    </ModalHeader>
    <ModalBody>
      <DetalleNiveles
        efectiva={efectiva}
        excluirArca={excluirArca}
        recalcularScoring={recalcularScoring}
        estadoPrevio={estadoPrevio}
      />
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCancelar}>
        Cancelar
      </Button>
      <Button color="primary" onClick={onConfirmar}>
        Confirmar
      </Button>
    </ModalFooter>
  </Modal>
)

DetalleNiveles.propTypes = {
  limpiezaCompleta: PropTypes.bool,
  recalcularScoring: PropTypes.bool,
  efectiva: PropTypes.array.isRequired,
  excluirArca: PropTypes.bool,
  estadoPrevio: PropTypes.object,
}
ConfirmacionNiveles.propTypes = {
  isOpen: PropTypes.bool,
  efectiva: PropTypes.array.isRequired,
  excluirArca: PropTypes.bool,
  recalcularScoring: PropTypes.bool,
  estadoPrevio: PropTypes.object,
  onCancelar: PropTypes.func.isRequired,
  onConfirmar: PropTypes.func.isRequired,
}

export default ConfirmacionNiveles
